// @ts-strict-ignore
export class Timer {

  public static readonly TIMER_EVENT: string = 'timer';

  private _timerId: any;
  private _isRunning: boolean = false;
  private _eventListeners: {} = {};
  private _delay: number;

  public constructor(delay: number) {
    this._delay = delay;
  }

  public start(): void {
    if (this._isRunning) {
      return;
    }
    this._timerId = setTimeout(() => {
      const keys: string[] = Object.keys(this._eventListeners);
      for (const key of keys) {
        this._eventListeners[key]();
      }
    }, this._delay);
    this._isRunning = true;
  }

  public reset(): void {
    if (!this._isRunning) {
      return;
    }
    clearTimeout(this._timerId);
    this._isRunning = false;
  }

  public addEventListener(type: string, callback: any): void {
    if (!type || !callback) {
      return;
    }
    this._eventListeners[type] = callback;
  }

  public removeEventListener(type: string, callback: any): void {
    if (!type || !callback) {
      return;
    }
    if (this.hasEventListener(type)) {
      delete this._eventListeners[type];
    }
  }

  public hasEventListener(type: string): boolean {
    if (!type) {
      return false;
    }
    return this._eventListeners[type] ? true : false;
  }

  public isRunning(): boolean {
    return this._isRunning;
  }
}
